// src/pages/Debug.jsx
import { useEffect } from "react";
import { supabase } from "../utils/supabaseClient";

export default function Debug() {
  useEffect(() => {
    console.log("[DEBUG] Clearing session, localStorage, and sessionStorage...");

    // Clear Supabase session
    supabase.auth.signOut();

    // Clear browser storage
    localStorage.clear();
    sessionStorage.clear();

    // Optional: clear referral cookie
    document.cookie = "referrer_id=; path=/; max-age=0";

    // Reload the app
    setTimeout(() => {
      window.location.href = "/";
    }, 500);
  }, []);

  return null;
}
